import {
  IMG_4wR7qeW9R8527OrIv7y3Lz,
  IMG_5MMPLIN2zyLziluVdBuyH2
} from '@ecomm/contentful-media'

/**
 * Country selector component constants.
 * Country data used in the country selector dropdown.
 */
export const COUNTRIES = {
  'en-GB': {
    src: IMG_5MMPLIN2zyLziluVdBuyH2.url,
    alt: 'Flag of the United Kingdom',
    label: 'UK',
    text: 'United Kingdom',
    url: 'https://simplisafe.co.uk'
  },
  'en-US': {
    src: IMG_4wR7qeW9R8527OrIv7y3Lz.url,
    alt: 'Flag of the United States',
    label: 'USA',
    text: 'United States',
    url: 'https://simplisafe.com'
  }
} as const
